module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAAAXNSR0IArs4c6QAAAItJREFUKFONkTESglAMRN/2XIK7OSM9FZRaORQ2QM8xoPcOVo52HsCCymhm/A2D/5My+7KTTWRmJ+As6UmkZGYPIANKYJBka7yDty+Q/8QRKCTdl/ASdP0FVEAv6R0G1sCgXYCdpKs3YqDrM3AAmhQY3NsU6I7HlGNyR09dA10s9QTs/91x82c2/foD7yhMoZ7fAwMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/play.png
// module id = 1jXs
// module chunks = 2